export default __webpack_public_path__ + "static/media/customer03.d76cbed8.jpg";